import React, {Component} from 'react';
import Select from 'react-select'
import countryListPL from '../constants/countryListPL'
import countryListEN from '../constants/countryListEN'
import countryListDE from '../constants/countryListDE'
import {getBookingEngineTranslations} from "@assets/js/functions/helpers";

const translations = getBookingEngineTranslations();

const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: 'none',
        '&:hover': {
            color: '#ffffff'
        }
    })
};

const locale = document.getElementById('root').dataset.locale;

class CountrySelector extends Component {
    constructor(props) {
        super(props)

        this.state = {
            options: this.options,
            value: null,
        }
    }

    componentDidMount() {
        const {initialValue} = this.props

        if (!initialValue) return;

        let value;

        switch (initialValue) {
            case 'polska':
                value = this.getCountryByValue('PL')
                break;
            case 'niemcy':
                value = this.getCountryByValue('DE')
                break;
            default:
                value = this.getCountryByValue(initialValue)
        }

        this.setState({value})
    }

    getCountryByValue = value => {
        const countryList = this.getCountryList()
        return countryList.filter(country => country.value === value)
    }

    getCountryList = () => {
        if (locale === 'pl') {
            return countryListPL
        } else if (locale === 'en') {
            return countryListEN
        } else if (locale === 'de') {
            return countryListDE
        }
    }

    handleChange = value => {
        this.props.onChange(value.value)
        this.setState({value})
    }

    render() {
        return (
            <Select
                options={this.getCountryList()}
                value={this.state.value}
                onChange={this.handleChange}
                className={`form-field--select ${this.props.form.errors.country && 'form-field--invalid'}`}
                theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    boxShadow: 0,
                    colors: {
                        ...theme.colors,
                        primary25: '#bfc6cc99',
                        primary50: '#bfc6cc99',
                        primary: '#bfc6cc99',
                        neutral0: 'black',
                    },
                })}
                placeholder={translations['placeholder-country']}
                styles={customStyles}
            />
        )
    }
}

export default CountrySelector
